import {
  AddressesAutocomplete,
  type AddressesAutocompleteProps,
} from '@/components/AddressesAutocomplete';
import { theme } from '@theguarantors/tg-package-material-ui';

export type RenterInviteAddressesAutocompleteProps = AddressesAutocompleteProps;

export const RenterInviteAddressesAutocomplete = (
  props: RenterInviteAddressesAutocompleteProps,
) => {
  return (
    <AddressesAutocomplete
      color="secondary"
      {...props}
      inputSx={{
        '& .MuiFormLabel-asterisk': {
          color: `${theme.palette.red[600]} !important`,
        },
        '& .MuiInputLabel-root': {
          [theme.breakpoints.down('md')]: {
            fontSize: '14px !important',
          },
        },
        ...props.inputSx,
      }}
    />
  );
};
